import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import LiveMetrics from './components/LiveMetrics';
// import CaseStudiesCarousel from './components/CaseStudiesCarousel';
import DigitalLabTeaser from './components/DigitalLabTeaser';
import TrustSignals from './components/TrustSignals';
import NewsletterSignup from './components/NewsletterSignup';
import Footer from './components/Footer';
import ServicesPreview from './components/ServicesPreview';

const Homepage = () => {
  useEffect(() => {
    // Smooth scroll behavior for anchor links
    document.documentElement.style.scrollBehavior = 'smooth';
    
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Singh Creations - Where Creativity Meets Technology | Digital Agency Portfolio Hub</title>
        <meta 
          name="description" 
          content="Transform your digital presence with Singh Creations. We craft exceptional web experiences, social media strategies, and mobile applications that drive real business growth. Trusted by 15+ clients with 340% average ROI." 
        />
        <meta name="keywords" content="digital agency, web development, social media marketing, app development, digital transformation, Singh Creations" />
        <meta name="author" content="Singh Creations" />
        
        {/* Open Graph Tags */}
        <meta property="og:title" content="Singh Creations - Where Creativity Meets Technology" />
        <meta property="og:description" content="Transform your digital presence with comprehensive digital solutions that drive real business growth." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://singhcreations.com" />
        <meta property="og:image" content="https://singhcreations.com/og-image.jpg" />
        
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Singh Creations - Digital Transformation Experts" />
        <meta name="twitter:description" content="Comprehensive digital solutions that elevate brands and create meaningful connections." />
        <meta name="twitter:image" content="https://singhcreations.com/twitter-image.jpg" />
        
        {/* Additional SEO Tags */}
        <link rel="canonical" href="https://singhcreations.com/home" />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        
        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Singh Creations",
            "description": "Digital agency specializing in web development, social media marketing, and app development",
            "url": "https://singhcreations.com",
            "logo": "https://singhcreations.com/logo.png",
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+91-7982843491",
              "contactType": "customer service",
              "email": "singhcreations23@gmail.com"
            },
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "",
              "addressLocality": "Tilak Nagar",
              "addressRegion": "india",
              "postalCode": "110018",
              "addressCountry": "India"
            },
            "sameAs": [
              "https://linkedin.com/company/singhcreations",
              "https://twitter.com/singhcreations",
              "https://instagram.com/singhcreations"
            ]
          })}
        </script>
      </Helmet>

      {/* Header */}
      <Header />

      {/* Main Content */}
      <main className="pt-16">
        {/* Hero Section */}
        <HeroSection />

        {/* Live Metrics Counter */}
        <LiveMetrics />

        {/* Services Preview with Interactive Demos */}
        {/* <ServicesPreview /> */}
        <ServicesPreview/>

        {/* Featured Case Studies Carousel */}
        {/* <CaseStudiesCarousel /> */}

        {/* Digital Lab Teaser with Free Tools */}
        <DigitalLabTeaser />

        {/* Trust Signals - Client Logos, Certifications, Awards */}
        <TrustSignals />

        {/* Newsletter Signup */}
        <NewsletterSignup />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Homepage;